import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import Footer from "./components/Footer/Footer";
import AboutUs from "./components/About Us/AboutUs";
import PrivacyPolicy from "./components/Privacy Policy/PrivacyPolicy";
import ContactUs from "./components/Contact Us/ContactUs";
import TermsAndConditions from "./components/Terms Conditions/TermsAndConditions";
import Disclaimer from "./components/Disclaimer/Disclaimer";
import Login from "./components/LoginPage/Login";
import Dashboard from "./components/LoginPage/Dashboard";
import WhatsAppFloat from "./components/WhatsAppFloat/WhatsAppFloat";

const Layout = ({ children }) => {
  const location = useLocation();

  // Routes that should NOT show navbar & footer
  const hideLayoutRoutes = ["/login", "/admin-dashboard"];

  const hideLayout = hideLayoutRoutes.includes(location.pathname);

  return (
    <>
      {!hideLayout && <Navbar />}
      {children}
      {!hideLayout && <Footer />}
      <WhatsAppFloat />
    </>
  );
};

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin-dashboard" element={<Dashboard />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
